module.exports = __webpack_public_path__ + "order/img/loading_anim_transparent.2f68bfe7.gif";